<oaj-notificaciones-general [iEstatus]="4"></oaj-notificaciones-general>
